module.exports = __webpack_public_path__ + "EnvironmentsIcon.aa1b864f0fee6bd926d033f7fb3bef05.hashedasset.svg";